import { compressToEncodedURIComponent, decompressFromEncodedURIComponent, } from './lz-string';
export function lzEncodeAndDecodeOptions(defaultValue) {
    const encode_and_decode = {
        encode: (value) => compressToEncodedURIComponent(JSON.stringify(value)),
        decode: (value) => {
            if (!value)
                return null;
            try {
                return JSON.parse(decompressFromEncodedURIComponent(value) ?? '');
            }
            catch {
                return null;
            }
        },
        defaultValue,
    };
    function curry_equality(equality_fn) {
        return { ...encode_and_decode, equalityFn: equality_fn };
    }
    return Object.assign(curry_equality, encode_and_decode);
}
